export default {
  forward: 'Forward',
  download: 'Download',
  forward_message: 'Forward Message',
  forward_image: 'Forward Image',
  forward_link: 'Forward Link',
  forward_file: 'Forward File',
};
